'use strict';

exports.__esModule = true;
exports.isFunction = isFunction;
exports.isGenerator = isGenerator;
exports.isObject = isObject;
exports.isPromise = isPromise;

function isFunction(subject) {
  return typeof subject === 'function';
}

function isGenerator(obj) {
  return !!obj && isFunction(obj.next) && isFunction(obj['throw']);
}

function isObject(obj) {
  return !!obj && typeof obj === 'object';
}

function isPromise(obj) {
  return !!obj && (isObject(obj) || isFunction(obj)) && isFunction(obj.then);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy90eXBlLWNoZWNrcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFPLFNBQVMsVUFBVSxDQUFFLE9BQU8sRUFBRTtBQUNuQyxTQUFPLE9BQU8sT0FBTyxLQUFLLFVBQVUsQ0FBQTtDQUNyQzs7QUFFTSxTQUFTLFdBQVcsQ0FBRSxHQUFHLEVBQUU7QUFDaEMsU0FBTyxDQUFDLENBQUMsR0FBRyxJQUFJLFVBQVUsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksVUFBVSxDQUFDLEdBQUcsU0FBTSxDQUFDLENBQUE7Q0FDOUQ7O0FBRU0sU0FBUyxRQUFRLENBQUUsR0FBRyxFQUFFO0FBQzdCLFNBQU8sQ0FBQyxDQUFDLEdBQUcsSUFBSSxPQUFPLEdBQUcsS0FBSyxRQUFRLENBQUE7Q0FDeEM7O0FBRU0sU0FBUyxTQUFTLENBQUUsR0FBRyxFQUFFO0FBQzlCLFNBQU8sQ0FBQyxDQUFDLEdBQUcsS0FBSyxRQUFRLENBQUMsR0FBRyxDQUFDLElBQUksVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFBLEFBQUMsSUFBSSxVQUFVLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFBO0NBQzNFIiwiZmlsZSI6InNyYy90eXBlLWNoZWNrcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBpc0Z1bmN0aW9uIChzdWJqZWN0KSB7XG4gIHJldHVybiB0eXBlb2Ygc3ViamVjdCA9PT0gJ2Z1bmN0aW9uJ1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaXNHZW5lcmF0b3IgKG9iaikge1xuICByZXR1cm4gISFvYmogJiYgaXNGdW5jdGlvbihvYmoubmV4dCkgJiYgaXNGdW5jdGlvbihvYmoudGhyb3cpXG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpc09iamVjdCAob2JqKSB7XG4gIHJldHVybiAhIW9iaiAmJiB0eXBlb2Ygb2JqID09PSAnb2JqZWN0J1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaXNQcm9taXNlIChvYmopIHtcbiAgcmV0dXJuICEhb2JqICYmIChpc09iamVjdChvYmopIHx8IGlzRnVuY3Rpb24ob2JqKSkgJiYgaXNGdW5jdGlvbihvYmoudGhlbilcbn1cbiJdfQ==




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/type-checks.js
 ** module id = 41
 ** module chunks = 0
 **/